export default __webpack_public_path__ + "static/media/logo.0360528e.png";